/**
 * @author David Beentjes
 * @company MDL Online
 * @copyright Copyright (c) 2018 MDL Online (https://mdlonline.nl)
 * @package MDLOnline_base
 */

define([
    'jquery',
    'domReady!'
], function ($) {
    'use strict';

    const $labels              = $('.review-control-vote label'),
          $persistentContainer = $('.product.info.detailed');

    // Add stars to the vote options
    $labels.each(function () {
        $(this).append('<i class="far fa-star star-empty"></i><i class="fas fa-star star-filled"></i>');
    });

    // Resets stars to empty state
    const resetStars = () => {
        $labels.children('.star-filled').hide();
        $labels.children('.star-empty').show();
    };

    // Toggles stars on and off
    const starToggle = element => {
        resetStars();
        element.children('.fa-star').toggle();
        element.prevAll('label').children('.fa-star').toggle();
    };

    // Returns to user selected star state after hover
    const starChecked = () => {
        resetStars();
        $('.review-control-vote input[type="radio"]:checked').each(function () {
            const $checkedRadio = $(this);

            $checkedRadio.next('label').children('.fa-star').toggle();
            $checkedRadio.prevAll('label').children('.fa-star').toggle();
        });
    };

    $persistentContainer.on('mouseenter mouseleave click', '.review-control-vote label', function () {
        starToggle($(this));
    });

    $persistentContainer.on('mouseleave', '.review-control-vote label', function () {
        starChecked();
    });
});
